var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('customerBasicInfo',{attrs:{"source":_vm.customerData,"list":_vm.companyBasicInfoList}}),_vm._v(" "),_c('payInfo',{attrs:{"source":_vm.customerData,"list":_vm.companyPayList}}),_vm._v(" "),_c('Invoicing',{attrs:{"data":_vm.customerData}}),_vm._v(" "),_c('recommender',{attrs:{"source":_vm.customerData,"list":_vm.recommenderList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }